import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LangLayout, { RootRedirect } from './i18n/LangLayout';
import Home from './pages/Home';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Locations from './pages/Locations';
import LocationDetails from './pages/LocationDetails';
import MyStamps from './pages/MyStamps';
import Profile from './pages/Profile';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import About from './pages/About';

// Language is the first path segment. Static, SEO-relevant routes are
// prerendered per language at build time (scripts/prerender.mjs); auth/
// dynamic routes render as a client shell.
function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route index element={<RootRedirect />} />
        <Route path=":lang" element={<LangLayout />}>
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="register" element={<Register />} />
          <Route path="verify-email" element={<VerifyEmail />} />
          <Route path="locations" element={<Locations />} />
          <Route path="locations/:slug" element={<LocationDetails />} />
          <Route path="my-stamps" element={<MyStamps />} />
          <Route path="profile" element={<Profile />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />
          <Route path="*" element={<Navigate to="" replace />} />
        </Route>
        {/* Any other top-level path → language detection. */}
        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
